import { atom } from "recoil";
export const crmshowAtom = atom({
  key: "showatom",
  default: false,
});
